import { render, staticRenderFns } from "./PermissionNameGenerator.vue?vue&type=template&id=306b4fca"
import script from "./PermissionNameGenerator.vue?vue&type=script&lang=js"
export * from "./PermissionNameGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports